exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".myCollContent .el-table .cell {\n  padding-left: 30px !important;\n}\n", ""]);

